// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2XPPO","textarea":"styles_textarea__K8hwn"};